// TODO: refactor contanst
import LoadingScreen from 'components/organisms/LoadingScreen';
import NotifyUtils from 'utils/NotifyUtils';
import { removeSessionToken } from 'utils/SessionUtils';

export function withLogin(Component, checkLogin = true, redirect = {}) {
  return function WithLoginHOC({ err, ...props }) {
    // if (maintain) {
    //   return <MaintainPage />;
    // }
    // nếu có lỗi server side thì sẽ in ở đây
    if (err) {
      console.error(err);
    }
    const { url, message } = redirect;
    const { isAuthenticated, isInvalidToken } = props;
    let msg = '';
    if (checkLogin && !isAuthenticated) {
      msg = message && message.length > 0 ? message : 'Bạn cần đăng nhập để vào được trang này ';
    } else if (isInvalidToken) {
      // server side
      // when user click other page , do with server side run -> check inValidToken
      msg = message && message.length > 0 ? message : 'Phiên làm việc của bạn đã hết hạn, vui lòng đăng nhập lại để có thể tiếp tục thao tác ';
    }

    if (msg && msg.length > 0) {
      removeSessionToken();
      NotifyUtils.error(msg);

      setTimeout(() => {
        const redirectUrl = window.location.pathname + window.location.search;
        window.location.replace(url && url.length > 0 ? url : `/home?login=true&redirectUrl=${encodeURIComponent(redirectUrl)}`);
      }, 2000);

      return <LoadingScreen />;
    }

    return <Component {...props} />;
  };
}
